import React from 'react';
import { string, bool } from 'prop-types';

export default function GoogleIcon({ icon, size = 'md', fill = false, withContainer = false, className = '' }) {
    const sizeClass = `size-${size}`;
    const containerClass = withContainer ? 'with-container' : '';
    const classes = `c-google-icon ${sizeClass} ${containerClass} ${className}`.trim();

    const style = fill ? { fontVariationSettings: "'FILL' 1" } : undefined;

    return (
        <span className={classes} style={style}>
            <span className="material-symbols-outlined">{icon}</span>
        </span>
    );
}

GoogleIcon.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    icon: string.isRequired,
    size: string,
    fill: bool,
    withContainer: bool,
    className: string
    /* eslint-enable react/no-typos */
};
